import { DeltaPill } from "./DeltaPill";

interface Props {
  label: string;
  value: string;
  previousLabel?: string;
  deltaPct: number | null;
}

export function KpiCard({ label, value, previousLabel, deltaPct }: Props) {
  return (
    <div className="nx-card p-4 flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <span className="nx-eyebrow">{label}</span>
        <DeltaPill deltaPct={deltaPct} />
      </div>
      <div className="text-3xl font-bold text-fg tracking-tight tabular-nums">
        {value}
      </div>
      {previousLabel && (
        <div className="text-2xs text-fg-subtle">
          vs <span className="text-fg-muted font-medium">{previousLabel}</span> período anterior
        </div>
      )}
    </div>
  );
}
